<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted(){
    console.warn('CICD ver. 2021/12/03 18:27');
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/_global.scss';
html, body{
  font-family: 'Roboto', sans-serif;
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: 100%;
}
</style>